import type { demo as Fr } from '../fr/demo';

/** Public demo texts — typed on the French. */
export const demo: typeof Fr = {
  lectureSeule: 'Read-only demo: nothing is saved. To try it with your own data, get in touch.',
  indisponible: 'This screen is not available in the demo.',
  bandeau: 'Live demo — fictional data, nothing is saved',
  vous: (role) => `You are: ${role}`,
  changerRole: 'Switch role',
  contacter: 'Contact the founder',
  site: 'Back to website',
  choisirTitre: 'Walk through Clefo as if you worked at the agency',
  choisirSousTitre: 'A fictional car rental agency with three months of activity. Choose who you are:',
  roles: {
    gerant_finances: { titre: 'The owner', texte: "This month's cash register, bank, outstanding payments, settings — all of the agency's money." },
    gerant: { titre: 'The manager', texte: 'The planning board, the fleet, maintenance, approvals from the counter.' },
    agent: { titre: 'The counter agent', texte: "Today's check-outs and returns, rental agreements, inspections, payments." },
  },
  entrer: 'Enter',
  langue: 'Voir la démo en français',
};
